'use client'
import {ListGroup} from "react-bootstrap";
import {NavLink} from "../../../libs/navlink/NavLink";

export default function FooterMenu() {
    const menus = [
        {
            header: "",
            items: [
                // {name: "FAQ", href: "/faq"},
                {name: "Privacy Policy", href: "/privacy-policy"},
                {name: "Terms of Service", href: "/terms"},
            ]
        },
    ];

    return (
        <div className={"flex flex-xxs-column gap-xs-0"} style={{gap: "7rem"}}>
            {
                menus.map((m, index) => (
                    <ListGroup key={index} className={'flex-row mb-3'}>
                        {
                            m.header ? (
                                <ListGroup.Item
                                    className={"border-0 bg-transparent footer-menu-title"}>{m.header}</ListGroup.Item>
                            ) : null
                        }
                        {
                            m.items.map((item, index) => (
                                <ListGroup.Item className={`border-0 bg-transparent ${index === 0 ? "ps-0" : ""}`}
                                                key={index}>
                                    <NavLink href={item.href}
                                             className={'text-decoration-underline'}>{item.name}</NavLink>
                                </ListGroup.Item>
                            ))
                        }
                    </ListGroup>
                ))
            }
        </div>
    );
}
